module.exports = __webpack_public_path__ + "img/form-cover.91664e87.png";